import { render } from "./TutoView.vue?vue&type=template&id=10debc2f"
import script from "./TutoView.vue?vue&type=script&lang=js"
export * from "./TutoView.vue?vue&type=script&lang=js"

import "./TutoView.vue?vue&type=style&index=0&id=10debc2f&lang=scss"

import exportComponent from "/var/www/vhosts/universalmusic.fr/sites/crm/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__